import React from "react";
import { Box, Typography, Grid, Container, Button } from "@mui/material";
import chair from "../assets/chairs.png";
import { useTheme } from "@mui/material/styles";
import { Slide } from "@mui/material";

const CareerPage = () => {
  const theme = useTheme();
  return (
      <Slide direction="up" in={true} timeout={500}>
    <Container
      maxWidth={false}
      sx={{
        maxWidth: "1300px",
        marginTop: { xs: "40px", sm: "80px", lg: "50px" },
        marginBottom: { xs: "0px", sm: "250px", lg: "250px" },
       
      }}>
      {/* Green Box Section */}
      <Box
        sx={{
          marginBottom: "20px", // Adds spacing below the green box
        }}>
        <Grid
          container
          spacing={0}
          sx={{
            backgroundColor: theme.palette.secondary.main,
            borderRadius: "5px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: { xs: "0px", md: "0px" },
          }}>
          {/* Left Column (Text) */}
          <Grid item xs={12} md={9}>
            <Box sx={{ marginX: { xs: "5px", sm: "10px" } }}>
              <Typography
                sx={{
                  fontWeight: "bold",
                  typography: { xs: "h6", sm: "h6", md: "h6" },
                }}>
                Careers
              </Typography>

              <Typography
                sx={{
                  fontWeight: "bold",
                  typography: { xs: "h6", sm: "h4", md: "h4" },
                }}>
                Sava-Tech Financial Services
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  marginBottom: "20px",
                  lineHeight: "1.8",
                  fontSize: "18px",
                }}>
                Financial technology company licensed by the Bank of Tanzania to
                carry out Microfinance business, own and operate Sava Loan. Sava
                Loan is an online digital lending platform that provides
                affordable financial services to African consumers and small
                businesses who have limited access to financial products from
                traditional banks.
              </Typography>
            </Box>
          </Grid>

          {/* Right Column (Image) */}
          <Grid item xs={12} md={3}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                paddingX: { xs: "10px", sm: "20px", md: "40px" },
                marginX: { md: 2 },
              }}>
              <img
                src={chair}
                alt="Career"
                style={{
                  width: "250px",
                  height: "250px",
                  borderRadius: "150px", // Makes the image circular
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>



      {/* <Box>
        <Box>
          <Typography sx={{ typography: { xs: "h6", sm: "h5" } }}>
            Open positions
          </Typography>
          <Box
            sx={{
              display: { xs: "column", sm: "flex" },
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}>
            <Box
              sx={{
                border: "solid 1px lightgrey",
                padding: { xs: "10px", sm: "30px" },
                backgroundColor: "white",
                borderRadius: 1,
              }}>
              <Typography variant="h5" sx={{}}>
                Microfinance manager
              </Typography>
              <Typography variant="body1">
                Sava-Tech Financial Services is a financial technology company
                licensed by the Bank of Tanzania to carry out Microfinance
                business, own and operate Sava Loan, Sava Loan is an online
                digital lending platform that provides affordable financial
                services to African consumers and small businesses who have
                limited access to financial products from traditional banks.
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingY: "2px",
                }}>
                <Typography variant="h6">Deadline: 12 June 2024</Typography>
                <Button variant="contained" size="small" color="primary">
                  READ MORE
                </Button>
              </Box>
            </Box>

            <Box
              sx={{
                border: "solid 1px lightgrey",
                padding: { xs: "10px", sm: "30px" },
                backgroundColor: "white",
                borderRadius: 1,
                marginTop: { xs: "10px", sm: "0px" },
              }}>
              <Typography variant="h5" sx={{}}>
                Customer Service Representative
              </Typography>
              <Typography variant="body1">
                Sava-Tech Financial Services is a financial technology company
                licensed by the Bank of Tanzania to carry out Microfinance
                business, own and operate Sava Loan, Sava Loan is an online
                digital lending platform that provides affordable financial
                services to African consumers and small businesses who have
                limited access to financial products from traditional banks.
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingY: "2px",
                }}>
                <Typography variant="h6">Deadline: 12 July 2024</Typography>
                <Button variant="contained" size="small" color="primary">
                  READ MORE
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box sx={{ marginTop: { xs: "10px", sm: "10px" } }}>
          <Box
            sx={{
              display: { xs: "column", sm: "flex" },
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}>
            <Box
              sx={{
                border: "solid 1px lightgrey",
                padding: { xs: "10px", sm: "30px" },
                backgroundColor: "white",
                borderRadius: 1,
              }}>
              <Typography variant="h5" sx={{}}>
                Microfinance manager
              </Typography>
              <Typography variant="body1">
                Sava-Tech Financial Services is a financial technology company
                licensed by the Bank of Tanzania to carry out Microfinance
                business, own and operate Sava Loan, Sava Loan is an online
                digital lending platform that provides affordable financial
                services to African consumers and small businesses who have
                limited access to financial products from traditional banks.
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingY: "2px",
                }}>
                <Typography variant="h6">Deadline: 12 June 2024</Typography>
                <Button variant="contained" size="small" color="primary">
                  READ MORE
                </Button>
              </Box>
            </Box>

            <Box
              sx={{
                border: "solid 1px lightgrey",
                padding: { xs: "10px", sm: "30px" },
                backgroundColor: "white",
                borderRadius: 1,
                marginTop: { xs: "10px", sm: "0px" },
              }}>
              <Typography variant="h5" sx={{}}>
                Customer Service Representative
              </Typography>
              <Typography variant="body1">
                Sava-Tech Financial Services is a financial technology company
                licensed by the Bank of Tanzania to carry out Microfinance
                business, own and operate Sava Loan, Sava Loan is an online
                digital lending platform that provides affordable financial
                services to African consumers and small businesses who have
                limited access to financial products from traditional banks.
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingY: "2px",
                }}>
                <Typography variant="h6">Deadline: 12 July 2024</Typography>
                <Button variant="contained" size="small" color="primary">
                  READ MORE
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box> */}
    </Container>

    </Slide>
  );
};

export default CareerPage;
